// extracted by mini-css-extract-plugin
export default {"auto-height-scrollbar-container":"auto-height-scrollbar_auto-height-scrollbar-container__DDGQe"};